import axios from 'axios';

import { definedQueryParams } from '@/helpers/object';

const FILTER_PAGE_SIZE = 50;

function listQuery(filters) {
  const query = { ...filters };
  if (query.media_eye === false) {
    delete query.media_eye;
  }
  return definedQueryParams(query);
}

function filterRows(path, payload = {}) {
  const params = {
    per_page: payload.per_page || FILTER_PAGE_SIZE
  };
  if (payload.q) {
    params.q = payload.q;
  }
  if (Array.isArray(payload.ids) && payload.ids.length > 0) {
    params.ids = payload.ids;
  }
  if (payload.mediaEye === true) {
    params.media_eye = true;
  }
  return axios.get(path, { params: definedQueryParams(params) }).then((r) => {
    const body = r.data && r.data.data;
    return (body && body.data) || [];
  });
}

const actions = {
  getUsers: (_context, filters) => {
    const signal = filters && filters.signal;
    const queryFilters = { ...filters };
    delete queryFilters.signal;
    return axios.get('/insight-users', { params: listQuery(queryFilters), signal }).then((r) => r.data.data);
  },

  getUser: (_context, { id, organizationUid }) => {
    return axios.get('/insight-users/' + id, {
      params: definedQueryParams({ organization_uid: organizationUid })
    }).then((r) => r.data.data);
  },

  saveUser: (_context, data) => {
    return axios.patch('/insight-users/' + data.id, data);
  },

  setPassword: (_context, { id, password, passwordConfirmation }) => {
    return axios.put('/insight-users/' + id + '/password', {
      password,
      password_confirmation: passwordConfirmation
    });
  },

  deleteUser: (_context, { id, organizationUid }) => {
    return axios.delete('/insight-users/' + id, {
      params: definedQueryParams({ organization_uid: organizationUid })
    });
  },

  sendInvites: (_context, payload) => {
    const ids = Array.isArray(payload) ? payload : payload.ids;
    const mediaEye = payload && payload.mediaEye === true;
    const clients = payload && payload.clients;
    return axios.post('/insight-users/invites', {
      ids,
      media_eye: mediaEye,
      clients
    });
  },

  loginAs: (_context, id) => {
    return axios.post('/insight-users/' + id + '/login-as').then((r) => r.data.data);
  },

  exportUsers: (_context, filters) => {
    return axios.get('/insight-users/export', {
      params: listQuery(filters),
      responseType: 'blob'
    }).then((r) => {
      const contentType = (r.headers && r.headers['content-type']) || '';
      if (contentType.indexOf('json') !== -1) {
        return { empty: true };
      }
      return { blob: r.data, format: filters.format };
    });
  },

  getFilterClients: (_context, payload = {}) => {
    return filterRows('/insight-users/filters/clients', payload);
  },

  getFilterProjects: (_context, payload = {}) => {
    return filterRows('/insight-users/filters/projects', payload);
  },

  getFilterTimeZones: () => {
    return axios.get('/insight-users/filters/time-zones').then((r) => r.data.data);
  },

  searchOrganizations: (_context, q) => {
    return axios.get('/insight-users/organizations', {
      params: definedQueryParams({ q, per_page: 50 })
    }).then((r) => r.data.data);
  },

  getOrganizationProjects: (_context, { uid, q }) => {
    return axios.get('/insight-users/organizations/' + encodeURIComponent(uid) + '/projects', {
      params: definedQueryParams({ q, per_page: 50 })
    }).then((r) => r.data.data);
  },

  getNotificationFields: (_context, uids) => {
    const list = Array.isArray(uids) ? uids : [uids];
    return axios.get('/insight-users/projects/notification-fields', {
      params: definedQueryParams({ uids: list })
    }).then((r) => r.data.data);
  }
};

export default {
  namespaced: true,
  actions
};
